import { render } from "./Evalvation.vue?vue&type=template&id=728cfd8b"
import script from "./Evalvation.vue?vue&type=script&lang=js"
export * from "./Evalvation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__